import { useEffect } from 'react'
import { useRadioGroupState } from '@react-stately/radio'
import { useRadioGroup } from '@react-aria/radio'
import Styles from './BrandKitWidgetSelect.module.scss'
import { RadioContext } from 'components/RadioGroup/RadioContext'
import { useBrandKits } from 'hooks/queries/brandKits/useBrandKits'
import { SelectableBrandKitWidget } from 'screens/BrandKits/components/SelectableBrandKitWidget/SelectableBrandKitWidget'

interface Props {
  onBrandKitChange: (id?: number) => void
  selectedBrandKit?: number
}

export const BrandKitWidgetSelect = ({ onBrandKitChange, selectedBrandKit }: Props) => {
  const brandKitsQuery = useBrandKits()
  const brandKits = brandKitsQuery.data

  const radioGroupState = useRadioGroupState({
    value: selectedBrandKit?.toString(),
    onChange: (value) => {
      onBrandKitChange(value ? parseInt(value) : undefined)
    },
  })

  
  const { radioGroupProps } = useRadioGroup({ label: 'Brand Kit Selection' }, radioGroupState)

  useEffect(() => {
    const latestBrandKit = brandKits && brandKits[brandKits.length - 1]?.id

    if (brandKitsQuery.isFetched && latestBrandKit && !selectedBrandKit) {
      onBrandKitChange(latestBrandKit)
    }
  }, [brandKits]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!brandKits) return null

  return (
    <div {...radioGroupProps} className={Styles.container} data-testid="brand-kit-widget-select">
      <RadioContext.Provider value={radioGroupState}>
        <div className={Styles.grid}>
          {brandKits.map((kit) => (
            <div key={kit.id} className={Styles.gridItem}>
              <SelectableBrandKitWidget brandKit={kit} value={kit.id} radioGroupState={radioGroupState} />
            </div>
          ))}
        </div>
      </RadioContext.Provider>
    </div>
  )
}
